import React from 'react';
import { Link } from 'react-router-dom';
import styles from './OrgMini.module.css';

function OrgMini() {
  return (
    <div className={styles.card}>
      <div className={styles.topStatBox}>
        <div>
          <div className={styles.statLabel}>Team Members</div>
          <span className={styles.statNumber}>7</span>
        </div>
        <button className={styles.expandIcon}>⛶</button>
      </div>

      <h3 className={styles.cardTitle}>Organization</h3>
      <span className={styles.cardCategory}>Team Structure</span>
      <p className={styles.cardDescription}>
        Review your organizational hierarchy, roles, and performance distribution across departments.
      </p>

      <div className={styles.cardFooter}>
        <Link to="/dashboard/resellers/org" className={styles.viewLink}>View full page →</Link>
      </div>
    </div>
  );
}

export default OrgMini;
